import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { QuizService } from '../services/quiz.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-quiz-review',
  templateUrl: './quiz-review.component.html',
  styleUrls: ['./quiz-review.component.css'],
})
export class QuizReviewComponent implements OnInit {
  answerData: any = null;
  reviewForm: FormGroup;
  showLoader = false;
  env = environment;
  answerId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private quizService: QuizService
  ) {
    this.reviewForm = this.fb.group({
      feedback: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.answerId = this.route.snapshot.paramMap.get('id');

    if (this.answerId) {
      this.loadAnswerData(this.answerId);
    } else {
      this.snackBar.open('Informações insuficientes para revisar o membro.', null, { duration: 3000 });
      this.router.navigate(['/devocional']);
    }
  }

  loadAnswerData(id: string | number): void {
    this.showLoader = true;
    this.quizService
      .getAnswerById(id)
      .then((res) => {
        this.answerData = res.data || res;

        if (this.answerData?.reviewed_feedback) {
          this.reviewForm.patchValue({ feedback: this.answerData.reviewed_feedback });
        }

        this.showLoader = false;
      })
      .catch((err) => {
        this.snackBar.open('Erro ao carregar os dados.', null, { duration: 3000 });
        this.showLoader = false;
        this.router.navigate(['/devocional']);
      });
  }

  onSubmit(): void {
    if (this.reviewForm.invalid || !this.answerId) {
      console.log('Formulário inválido ou ID da resposta ausente.');
      return;
    }

    this.loaderService.showLoader();
    const feedback = this.reviewForm.value.feedback;

    this.quizService
      .reviewAnswer(this.answerId, feedback)
      .then((res) => {
        this.snackBar.open('Revisão salva com sucesso!', null, { duration: 3000 });
        this.loaderService.closeLoader();
        const quizId = this.answerData?.quiz_id || this.answerData?.quiz?.id;
        this.router.navigate(['/devocional/view', quizId]);
      })
      .catch((err) => {
        this.snackBar.open(err.error?.message || 'Ocorreu um erro ao salvar a revisão.', null, { duration: 3000 });
        this.loaderService.closeLoader();
      });
  }

  getAvatarUrl(avatar: string | undefined): string {
    if (avatar) {
      return this.env.endPointApi + 'user/avatar/' + avatar;
    }
    return '';
  }

  getFirstLetter(name: string): string {
    return name ? name.charAt(0).toUpperCase() : '?';
  }

  formatShortName(fullName: string): string {
    if (!fullName) return '';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0];
    return `${parts[0]} ${parts[parts.length - 1]}`;
  }
}

